'use client'

import { useEffect, useRef } from 'react'
import { analytics } from '@repo/analytics'

/**
 * Fires a single `property_view` when a property detail page mounts — the true
 * "viewed details" funnel step. Rendered by the detail page server component,
 * which already has the property data. Replaces the old (mislabeled) firing on
 * listing-card click.
 */
export default function PropertyViewTracker({ propertyId, propertyType, city, propertyName }) {
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current || !propertyId) return
    fired.current = true
    analytics.propertyView(propertyId, propertyType, city, propertyName)
  }, [propertyId, propertyType, city, propertyName])

  return null
}
